module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "runner-manager"
  }, [_c('sub-navigation', {
    attrs: {
      "items": _vm.menuItems
    }
  }), _vm._v(" "), _c('container', [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fe85ef8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RunnerManager.vue
// module id = 1667
// module chunks = 2